import { render, staticRenderFns } from "./GenericMessage.vue?vue&type=template&id=77c45819&"
import script from "./GenericMessage.vue?vue&type=script&lang=js&"
export * from "./GenericMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports